export const iconFontAwesomeFoodBeverageCheese = (
	<i className="fa-solid fa-cheese"></i>
);
